import { merge } from 'lodash';
import { setCommonStyles } from './styleCommon';

import { getAnnotationStyles } from './annotation';
import event from './event';
import flag from './flag';
import { getIndicatorStyles } from './indicator';
import { getMarkerStyles } from './marker';
import { getToolStyles } from './tool';
import { getPanelStyles } from './panel';
import { getPanelLowerStyles } from './panelLower';
import { getPanelYAxisLeftStyles } from './panelYAxisLeft';

// Dynamically generate default styles
const generateDefaultStyles = (commonStyles = {}) => {
	// Apply any common style overrides to the `commonStyleOverrides` object.
	// Later, when calls such as `getIndicatorStyles()` or `getToolStyles` are made, they will
	// reference the updated `commonStyleOverrides` object.
	setCommonStyles(commonStyles);
	// Use 'merge' here to break references within these objects
	return merge({}, {
		annotation: getAnnotationStyles(),
		event,
		flag,
		indicator: getIndicatorStyles(),
		marker: getMarkerStyles(),
		panel: getPanelStyles(),
		panelLower: getPanelLowerStyles(),
		panelYAxisLeft: getPanelYAxisLeftStyles(),
		tool: getToolStyles()
	});
};

export default generateDefaultStyles;
